import { useEffect, useState } from "react";
import { useGeneric } from "../useGeneric";

export default function Pkd() {
  const [searchStringPKD, setSearchStringPKD] = useState<any>("");
  const [searchStringNACE, setSearchStringNACE] = useState<any>("");
  const [searchStringNumber, setSearchStringNumber] = useState<any>("");

  useEffect(() => {
    if (searchStringNACE?.length > 0) {
      setSearchStringNumber("");
      setSearchStringPKD("");
    }
  }, [searchStringNACE]);

  useEffect(() => {
    if (searchStringPKD?.length > 0) {
      setSearchStringNumber("");
      setSearchStringNACE("");
    }
  }, [searchStringPKD]);

  useEffect(() => {
    if (searchStringNumber?.length > 0) {
      setSearchStringNACE("");
      setSearchStringPKD("");
    }
  }, [searchStringNumber]);

  const loadData: any = useGeneric({
    name: "pkd",
    query: {
      pl_heading: searchStringPKD || undefined,
      en_heading: searchStringNACE || undefined,
      number: searchStringNumber || undefined,
    },
    noRefresh: true,
    update: searchStringPKD + searchStringNACE + searchStringNumber,
  });

  console.log(loadData);

  return (
    <div className="fullScreen">
      <div
        style={{
          position: "sticky",
          top: 0,
          left: 0,
          zIndex: 3,
          background: "whitesmoke",
          padding: "4px",
        }}
      >
        <div style={{ padding: "5px" }}>PKD 2025 / NACE v. 2.1</div>
        <div className="filters" style={{ display: "flex", gap: "20px" }}>
          <div className="filter-single">
            <label className="filter-name" htmlFor="nr">
              Numer
            </label>
            <input
              type="search"
              className="filter-value"
              name="nr"
              placeholder="Sekcja, dział, klasa, podklasa"
              value={searchStringNumber}
              onChange={(e) => setSearchStringNumber(e.target.value)}
            />
          </div>
          <div className="filter-single">
            <label className="filter-name" htmlFor="pl">
              PKD
            </label>
            <input
              type="search"
              className="filter-value"
              name="pl"
              placeholder="polski"
              value={searchStringPKD}
              onChange={(e) => setSearchStringPKD(e.target.value)}
            />
          </div>
          <div className="filter-single">
            <label className="filter-name" htmlFor="en">
              NACE
            </label>
            <input
              type="search"
              className="filter-value"
              name="en"
              placeholder="English"
              value={searchStringNACE}
              onChange={(e) => setSearchStringNACE(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div>
        <table className="universal-table big">
          <thead>
            <tr>
              <th>Sekcja</th>
              <th>Nazwa sekcji</th>
              <th>Dział</th>
              <th>Grupa</th>
              <th>Klasa</th>
              <th>Podklasa PKD</th>
              <th>Nazwa grupowania PKD 2025</th>
              <th>Nazwa grupowania NACE Rev. 2.1</th>
            </tr>
          </thead>
          <tbody>
            {!loadData?.loading && loadData?.rows?.length ? (
              loadData?.rows?.map((i: any) => {
                const pl = i?.pl_heading;
                const en = i?.en_heading;

                const formPL = pl.replace(
                  new RegExp(`(${searchStringPKD})`, "gi"),
                  `<span style="background:lightgreen;">$1</span>`
                );

                const formEN = i?.en_heading
                  ? en.replace(
                      new RegExp(`(${searchStringNACE})`, "gi"),
                      `<span style="background:lightgreen;">$1</span>`
                    )
                  : i?.subclass?.match(/Z/)
                  ? `<span style="color:grey;font-size:86%;">${i?.en_parent_heading}</span>`
                  : `<span style="color:grey;font-size:86%;">brak oficjalnej nazwy NACE - podklasy tylko w PKD</span>`;

                return (
                  <tr>
                    <td style={{ textAlign: "center" }}>{i?.section}</td>
                    <td style={{ fontSize: "70%", maxWidth: "350px" }}>
                      <div className="text-wrap-pretty">
                        <div
                          style={{ borderBottom: "1px solid rgb(215,215,215)" }}
                        >
                          {i?.pl_section_heading}
                        </div>
                        <div style={{ fontStyle: "italic", color: "grey" }}>
                          {i?.en_section_heading}
                        </div>
                      </div>
                    </td>
                    <td style={{ textAlign: "center" }}>{i?.division}</td>
                    <td style={{ textAlign: "center" }}>{i?.group}</td>
                    <td
                      onClick={() => setSearchStringNumber(i?.class)}
                      style={{
                        cursor: "pointer",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      {i?.class}
                    </td>
                    <td style={{ minWidth: "70px" }}>{i?.subclass}</td>
                    <td
                      style={{ width: "30%" }}
                      dangerouslySetInnerHTML={{ __html: formPL }}
                    ></td>
                    <td
                      style={{ width: "30%" }}
                      dangerouslySetInnerHTML={{ __html: formEN }}
                    ></td>
                  </tr>
                );
              })
            ) : (
              <></>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
